import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
/* global window */


import React, { Component } from 'react';
import styled from 'styled-components';
import Scroll from 'react-scroll-to-element';
import { mediaUrl } from '@wingscms/sdk';
import { getViewportDimensions } from '../../../../../../lib/utils';
import { DEFAULT_VIEWPORT_HEIGHT, DEFAULT_VIEWPORT_WIDTH } from '../../../../../../lib/constants';
import widont from 'widont';
import Title from './Title';
import downArrowImage from '../../../../../img/arrow-down.svg';
var Container = styled.header.withConfig({
  displayName: "LandingSection__Container",
  componentId: "m1h0vd-0"
})(["cursor:pointer;width:100vw;height:calc(100vh - 84px);background-color:", ";position:relative;overflow:hidden;transition:0.2s all ease-in-out;@media screen and (max-width:800px){height:calc(100vh - 60px);}"], function (_ref) {
  var theme = _ref.theme;
  return theme.landingSectionBackgroundColor;
});
var BackgroundImageContainerOuter = styled.div.withConfig({
  displayName: "LandingSection__BackgroundImageContainerOuter",
  componentId: "m1h0vd-1"
})(["position:absolute;width:100%;height:100%;overflow:hidden;"]);
var BackgroundOverlay = styled.div.withConfig({
  displayName: "LandingSection__BackgroundOverlay",
  componentId: "m1h0vd-2"
})(["height:100%;width:100%;position:absolute;background-image:linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0) 70%,rgba(0,0,0,0.3) 90%);"]);

var backgroundImage = function backgroundImage(props) {
  var _getViewportDimension = getViewportDimensions(),
      _getViewportDimension2 = _getViewportDimension.height,
      height = _getViewportDimension2 === void 0 ? DEFAULT_VIEWPORT_HEIGHT : _getViewportDimension2,
      _getViewportDimension3 = _getViewportDimension.width,
      width = _getViewportDimension3 === void 0 ? DEFAULT_VIEWPORT_WIDTH : _getViewportDimension3;

  return mediaUrl(props.backgroundImage, width > height ? {
    width: width
  } : {
    height: height
  });
};

var BackgroundImageContainer = styled.div.withConfig({
  displayName: "LandingSection__BackgroundImageContainer",
  componentId: "m1h0vd-3"
})(["width:100%;height:100%;position:absolute;background-image:url(\"", "\");background-size:cover;background-repeat:no-repeat;background-position:", ";animation:25s ease-out zoom forwards;@keyframes zoom{from{transform:scale(1);}to{transform:scale(1.1);}}"], backgroundImage, function (props) {
  return props.backgroundPosition;
});
var ContentContainer = styled.div.withConfig({
  displayName: "LandingSection__ContentContainer",
  componentId: "m1h0vd-4"
})(["width:100%;position:absolute;left:0;bottom:0;"]);
var TitleContainer = styled.div.withConfig({
  displayName: "LandingSection__TitleContainer",
  componentId: "m1h0vd-5"
})(["padding:0 10px;position:relative;text-align:center;@media screen and (max-width:800px){padding:20px 0;}"]);
var ArrowContainer = styled.div.withConfig({
  displayName: "LandingSection__ArrowContainer",
  componentId: "m1h0vd-6"
})(["width:100%;position:relative;text-align:center;margin:30px 0;@media screen and (min-width:800px){}"]);
var Arrow = styled.img.withConfig({
  displayName: "LandingSection__Arrow",
  componentId: "m1h0vd-7"
})(["margin:10px auto;@media screen and (max-width:800px){height:25px;margin:10px auto 40px auto;}"]);

var LandingSection =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(LandingSection, _Component);

  function LandingSection() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      scrollY: 0
    };

    _this.updatePercentage = function () {
      return requestAnimationFrame(function () {
        return _this.setState({
          scrollY: window.scrollY
        });
      });
    };

    return _this;
  }

  var _proto = LandingSection.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    window.addEventListener('scroll', function () {
      return _this2.updatePercentage;
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this3 = this;

    window.removeEventListener('scroll', function () {
      return _this3.updatePercentage;
    });
  };

  _proto.render = function render() {
    if (typeof window === 'undefined') return React.createElement("div", null);
    var _this$props = this.props,
        _this$props$article = _this$props.article;
    _this$props$article = _this$props$article === void 0 ? {} : _this$props$article;
    var title = _this$props$article.title,
        _this$props$article$i = _this$props$article.image,
        image = _this$props$article$i === void 0 ? {} : _this$props$article$i,
        titleAttribute = _this$props.titleAttribute;
    var scrollY = this.state.scrollY;
    var backgroundImage = image && image.url || '';
    return React.createElement("div", null, React.createElement(Scroll, {
      type: "id",
      element: "article-start"
    }, React.createElement(Container, {
      id: "landing-section",
      title: titleAttribute
    }, React.createElement(BackgroundImageContainerOuter, {
      style: {
        marginTop: scrollY > 84 ? scrollY / 2 - 84 / 2 : 0
      }
    }, React.createElement(BackgroundImageContainer, {
      backgroundImage: backgroundImage,
      backgroundPosition: "center center"
    }), React.createElement(BackgroundOverlay, null)), React.createElement(ContentContainer, null, React.createElement(TitleContainer, null, React.createElement(Title, null, React.createElement("span", null, widont(title)))), React.createElement(ArrowContainer, null, React.createElement(Arrow, {
      src: downArrowImage
    }))))));
  };

  return LandingSection;
}(Component);

export { LandingSection as default };